<div class="generate-receipt-modal">
	<div class="modal-header zk-flex zk-p-4 zk-items-start">
		<h1 class="modal-title">
			<span
				*ngIf="status === 'success'"
				class="seal zk-rounded-full zk-bg-success zk-mt-4"
			>
				<zk-icon [name]="'check'"></zk-icon>
			</span>

			<span class="modal-title-text zk-mt-4 zk-whitespace-pre-line">
				<ng-container *ngIf="status === 'success'">
					{{ 'SCHEDULE.RECEIPT.SUCCESS' | translate }}
				</ng-container>
				<ng-container *ngIf="status === 'error' && modalMessage">
					{{ 'SCHEDULE.RECEIPT.TITLE_ERROR_REQUIRED_DATA' | translate }}
				</ng-container>
				<ng-container *ngIf="status === 'error' && !modalMessage">
					{{ 'SCHEDULE.RECEIPT.TITLE_ERROR' | translate }}
				</ng-container>
			</span>
		</h1>

		<button type="button" class="close" aria-label="Close" (click)="close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>

	<div class="modal-body">
		<div class="modal-body-message" *ngIf="status == 'success'">
			{{ 'SCHEDULE.RECEIPT.SUCCESS_MESSAGE' | translate }}
		</div>
		<div
			class="modal-body-message zk-whitespace-pre-line"
			*ngIf="status == 'error'"
		>
			{{
				modalMessage || ('SCHEDULE.RECEIPT.ERROR_DEFAULT_MESSAGE' | translate)
			}}
		</div>
	</div>

	<div class="modal-footer zk-mb-1">
		<button
			(click)="close()"
			id="receipt-button-close"
			type="button"
			zk-button
			zkButtonSize="medium"
		>
			{{ 'SCHEDULE.RECEIPT.BACK' | translate }}
		</button>
	</div>
</div>
